module.exports = "/images/tr.svg";